import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useSelector } from 'react-redux';

import { isLessThanBreakpoint } from 'dpl/util/grid';
import { RESULTS_TYPES } from 'dpl/puppy_search_results/utils/constants';

import ExposedFilterMenu from './ExposedFilterMenu';
import GenderFilterButtons from './GenderFilterButtons';
import LocationFilterButton from './LocationFilterButton';
import HealthTestFilterButton from './HealthTestFilterButton';
import useStickyFilters from '../hooks/useStickyFilters';
import ColorFilterButton from './ColorFilterButton';
import CoatTypeFilterButton from './CoatTypeFilterButton';
import SizeFilterButton from './SizeFilterButton';

const IS_LT_MD = isLessThanBreakpoint('md');

export default function ExposedFilters({
  className,
  resultsType,
  totalItemCount
}) {
  const containerRef = useRef(null);
  const stickyFilters = useStickyFilters({ container: containerRef.current });
  const { isNewMobileLayoutEnabled } = useSelector(({ server }) => server);

  const shouldShowPuppyFilters =
    resultsType === RESULTS_TYPES.PUPPIES || isNewMobileLayoutEnabled;

  return (
    <div
      style={{ top: -1 }}
      ref={containerRef}
      className={classnames(
        'SearchResultsExposedFilters sticky z-999',
        {
          'overflow-auto no-scrollbars': IS_LT_MD,
          'bg-white': !stickyFilters.stuck,
          'bg-sand bb b--default': stickyFilters.stuck
        },
        className
      )}
    >
      <div className="container-xxl flex gap-8">
        <LocationFilterButton
          resultsType={resultsType}
          totalItemCount={totalItemCount}
        />
        {shouldShowPuppyFilters ? (
          <>
            <GenderFilterButtons />
            <SizeFilterButton
              resultsType={resultsType}
              totalItemCount={totalItemCount}
            />
            <CoatTypeFilterButton
              resultsType={resultsType}
              totalItemCount={totalItemCount}
            />
            <ColorFilterButton
              resultsType={resultsType}
              totalItemCount={totalItemCount}
            />
          </>
        ) : (
          <HealthTestFilterButton
            resultsType={resultsType}
            totalItemCount={totalItemCount}
          />
        )}
        <ExposedFilterMenu
          resultsType={resultsType}
          totalItemCount={totalItemCount}
        />
      </div>
    </div>
  );
}

ExposedFilters.propTypes = {
  className: PropTypes.string,
  resultsType: PropTypes.string.isRequired,
  totalItemCount: PropTypes.number.isRequired
};

ExposedFilters.defaultProps = {
  className: null
};
